// This file is auto-generated by @hey-api/openapi-ts

import { oc } from '@orpc/contract';
import { z } from 'zod';

import { zAdminAdminAdjustCreditsBody, zAdminAdminAdjustCreditsPath, zAdminAdminApplyOptimizePatchPath, zAdminAdminApprovePricingVersionPath, zAdminAdminBillingQuoteBody, zAdminAdminDeleteAssetPath, zAdminAdminDeleteDesignDictPath, zAdminAdminDeleteDesignDictQuery, zAdminAdminDeleteDesignDictTypePath, zAdminAdminDeleteDesignSkillPath, zAdminAdminDeleteFontFacePath, zAdminAdminDeleteFontPath, zAdminAdminDeleteKgTriplePath, zAdminAdminDeleteLikeQuery, zAdminAdminDeleteModelPath, zAdminAdminDeleteNoticePath, zAdminAdminDesignContentResyncQuery, zAdminAdminDesignDecisionLogDetailPath, zAdminAdminDesignDecisionLogsQuery, zAdminAdminDesignDictsQuery, zAdminAdminDesignDictTypesQuery, zAdminAdminDesignSkillsQuery, zAdminAdminDesignStageReviewsQuery, zAdminAdminDesignSystemPromptsQuery, zAdminAdminDiscardExportDlqPath, zAdminAdminDiscardHydrateDlqPath, zAdminAdminDismissOptimizePatchPath, zAdminAdminFontsUploadBody, zAdminAdminGenerateCardKeysBody, zAdminAdminGetNoticePath, zAdminAdminGetPricingVersionPath, zAdminAdminGetUserPath, zAdminAdminListAssetsQuery, zAdminAdminListCardKeysQuery, zAdminAdminListExportDlqQuery, zAdminAdminListFontsQuery, zAdminAdminListHydrateDlqQuery, zAdminAdminListKgTriplesQuery, zAdminAdminListLikesQuery, zAdminAdminListModelsQuery, zAdminAdminListNoticesQuery, zAdminAdminListOptimizePatchesQuery, zAdminAdminListPricingVersionsQuery, zAdminAdminListProjectsQuery, zAdminAdminListUsersQuery, zAdminAdminMarginSummaryQuery, zAdminAdminModelUsageListQuery, zAdminAdminModelUsageSummaryQuery, zAdminAdminPatchUserBody, zAdminAdminPatchUserPath, zAdminAdminPlazaApprovePath, zAdminAdminPlazaCoverBody, zAdminAdminPlazaCoverPath, zAdminAdminPlazaDeletePath, zAdminAdminPlazaDetailPath, zAdminAdminPlazaFeedQuery, zAdminAdminPlazaListQuery, zAdminAdminPlazaPublishedQuery, zAdminAdminPlazaRejectBody, zAdminAdminPlazaRejectPath, zAdminAdminPlazaTitleBody, zAdminAdminPlazaTitlePath, zAdminAdminPlazaVisibilityBody, zAdminAdminPlazaVisibilityPath, zAdminAdminRejectPricingVersionBody, zAdminAdminRejectPricingVersionPath, zAdminAdminReplayExportDlqBody, zAdminAdminReplayHydrateDlqBody, zAdminAdminRevokeCardKeysBody, zAdminAdminRunColdArchiveQuery, zAdminAdminSubmitPricingVersionPath, zAdminAdminSyncModelPricesBody, zAdminAdminUpsertDesignCanvasToolBody, zAdminAdminUpsertDesignDictBody, zAdminAdminUpsertDesignDictTypeBody, zAdminAdminUpsertDesignRuntimeSettingBody, zAdminAdminUpsertDesignSkillBody, zAdminAdminUpsertDesignSystemPromptBody, zAdminAdminUpsertFontBody, zAdminAdminUpsertModelBody, zAdminAdminUpsertNoticeBody, zAdminAdminUpsertPricingVersionBody, zAdminAdminUserLedgerPath, zAdminAdminUserLedgerQuery, zAssetsDeleteMyAssetPath, zAssetsListMyAssetsQuery, zAssetsRegisterMyAssetBody, zAuthAuthGoogleBody, zAuthAuthPatchProfileBody, zAuthCaptchaVerifyBody, zAuthEmailActivateBody, zAuthEmailLoginBody, zAuthEmailSendCodeBody, zAuthEmailVerifyCodeBody, zChatAudioJobsCreateAudioJobBody, zChatAudioJobsGetAudioJobPath, zChatAudioJobsStreamAudioJobEventsPath, zChatImageJobsCreateImageJobBody, zChatImageJobsGetImageJobPath, zChatImageJobsStreamImageJobEventsPath, zChatLottieJobsCreateLottieJobBody, zChatLottieJobsGetLottieJobPath, zChatLottieJobsStreamLottieJobEventsPath, zChatPostAgentTurnBody, zChatPostAudioBody, zChatPostImageBody, zChatPostMessageBody, zChatPostVideoBody, zChatSessionsGetSessionsQuery, zChatSessionsPutSessionBody, zChatSessionsRemoveSessionPath, zChatVideoJobsCreateVideoJobBody, zChatVideoJobsGetVideoJobPath, zChatVideoJobsStreamVideoJobEventsPath, zCollabCollabRoomTokenBody, zDesignDesignLongMemoryBody, zDesignDesignLottieGenerateBody, zDesignDesignPluginsInstallBody, zDesignDesignRunBody, zDesignDesignRunCancelPath, zDesignDesignRunCommandsAckBody, zDesignDesignRunCommandsAckPath, zDesignDesignRunCommandsPath, zDesignDesignRunCommandsQuery, zDesignDesignRunEventsPath, zDesignDesignRunEventsQuery, zDesignDesignRunPausePath, zDesignDesignRunResumeBody, zDesignDesignRunResumePath, zDesignDesignRunSceneFeedbackBody, zDesignDesignRunSceneFeedbackPath, zDesignDesignRunStatusPath, zDesignDesignRunTracePath, zDesignDesignRunTraceQuery, zDesignDesignSkillsDeletePath, zDesignDesignSkillsImportZipBody, zDesignDesignSkillsPickerQuery, zDesignDesignSkillsSetEnabledBody, zDesignDesignSkillsSetEnabledPath, zDesignDesignSkillsUpsertBody, zDesignExportJobsCreateExportJobBody, zDesignExportJobsDownloadExportJobPath, zDesignExportJobsGetExportJobPath, zDesignHydrateJobsCreateHydrateJobBody, zDesignHydrateJobsGetHydrateJobPath, zFontsDeleteMyFontPath, zFontsListFontsEndpointQuery, zFontsRegisterFontBody, zFontsUploadFontFileBody, zImageProcessJobsCreateImageProcessJobBody, zImageProcessJobsGetImageProcessJobPath, zImageProcessJobsStreamImageProcessJobEventsPath, zImageToolsPostImageProcessBody, zImportImportImageBody, zImportJobsCreateImportJobBody, zImportJobsGetImportJobPath, zMcpCanvasAckPendingBody, zMcpCanvasCallToolBody, zMcpCanvasListPendingQuery, zMcpCanvasSessionHeartbeatBody, zMeMeByokDeletePath, zMeMeByokUpsertBody, zMeMeLikedListQuery, zMeMeLikedSyncBody, zMeMeLikePath, zMeMeUnlikePath, zMockupGetMockupTemplateKitPath, zMockupGetMockupTemplateKitQuery, zMockupPostMockupAutoBakeBody, zMockupPostMockupBatchRenderBody, zMockupPostMockupRenderBody, zNoticesNoticesListQuery, zOrgsAcceptInvitePath, zOrgsCreateOrgBody, zOrgsDeclineInvitePath, zOrgsGetOrgPath, zOrgsInviteMemberBody, zOrgsInviteMemberPath, zOrgsListMembersPath, zOrgsListOrgPendingInvitesPath, zOrgsRemoveMemberPath, zOrgsRenameOrgBody, zOrgsRenameOrgPath, zPlazaPlazaAdminApprovePath, zPlazaPlazaAdminListQuery, zPlazaPlazaAdminRejectBody, zPlazaPlazaAdminRejectPath, zPlazaPlazaFeedQuery, zPlazaPlazaItemPath, zPlazaPlazaItemUsePath, zPlazaPlazaSubmitBody, zProjectsBatchRemoveBody, zProjectsGetOnePath, zProjectsListMyProjectsQuery, zProjectsPatchOneBody, zProjectsPatchOneHeaders, zProjectsPatchOnePath, zProjectsRemovePath, zProjectsSetProjectOrgBody, zProjectsSetProjectOrgPath, zProjectsUpsertBody, zProjectsUpsertHeaders, zSharesSharesCreateBody, zSharesSharesGetPath, zSharesSharesPatchBody, zSharesSharesPatchPath, zSharesSharesUpdateDocumentBody, zSharesSharesUpdateDocumentPath, zUploadsAbortUploadJobPath, zUploadsCompleteUploadJobPath, zUploadsCreateUploadSessionBody, zUploadsDeleteUploadedFilePath, zUploadsGetUploadContentByUrlQuery, zUploadsGetUploadedFilePath, zUploadsGetUploadJobPath, zUploadsStreamUploadJobEventsPath, zUploadsUploadJobPartPath, zUsersUsersLookupQuery, zUsersUsersSearchQuery, zWalletWalletLedgerQuery, zWalletWalletRedeemBody } from './zod.gen';

/**
 * Health
 */
export const healthHealth = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'health-health',
    path: '/health',
    summary: 'Health',
    tags: ['health']
});

/**
 * Auth Config
 */
export const authAuthConfig = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'auth-auth_config',
    path: '/auth/config',
    summary: 'Auth Config',
    tags: ['auth']
});

/**
 * Auth Google
 */
export const authAuthGoogle = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-auth_google',
    path: '/auth/google',
    summary: 'Auth Google',
    tags: ['auth']
}).input(z.object({ body: zAuthAuthGoogleBody }));

/**
 * Email Send Code
 *
 * Send 6-digit email verification code for login.
 */
export const authEmailSendCode = oc.route({
    description: 'Send 6-digit email verification code for login.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-email_send_code',
    path: '/auth/email/send-code',
    summary: 'Email Send Code',
    tags: ['auth']
}).input(z.object({ body: zAuthEmailSendCodeBody }));

/**
 * Email Activate
 *
 * Consume one-time /activate/{{id}} link → session (email magic-link mails).
 */
export const authEmailActivate = oc.route({
    description: 'Consume one-time /activate/{{id}} link → session (email magic-link mails).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-email_activate',
    path: '/auth/email/activate',
    summary: 'Email Activate',
    tags: ['auth']
}).input(z.object({ body: zAuthEmailActivateBody }));

/**
 * Email Verify Code
 *
 * Verify 6-digit email code → session.
 */
export const authEmailVerifyCode = oc.route({
    description: 'Verify 6-digit email code → session.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-email_verify_code',
    path: '/auth/email/verify-code',
    summary: 'Email Verify Code',
    tags: ['auth']
}).input(z.object({ body: zAuthEmailVerifyCodeBody }));

/**
 * Captcha Create
 */
export const authCaptchaCreate = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-captcha_create',
    path: '/auth/captcha/create',
    summary: 'Captcha Create',
    tags: ['auth']
});

/**
 * Captcha Verify
 */
export const authCaptchaVerify = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-captcha_verify',
    path: '/auth/captcha/verify',
    summary: 'Captcha Verify',
    tags: ['auth']
}).input(z.object({ body: zAuthCaptchaVerifyBody }));

/**
 * Email Login
 *
 * Super-admin password bootstrap only. Public users sign in via /email/verify-code.
 */
export const authEmailLogin = oc.route({
    description: 'Super-admin password bootstrap only. Public users sign in via /email/verify-code.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-email_login',
    path: '/auth/email/login',
    summary: 'Email Login',
    tags: ['auth']
}).input(z.object({ body: zAuthEmailLoginBody }));

/**
 * Auth Me
 */
export const authAuthMe = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'auth-auth_me',
    path: '/auth/me',
    summary: 'Auth Me',
    tags: ['auth']
});

/**
 * Auth Patch Profile
 */
export const authAuthPatchProfile = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'auth-auth_patch_profile',
    path: '/auth/profile',
    summary: 'Auth Patch Profile',
    tags: ['auth']
}).input(z.object({ body: zAuthAuthPatchProfileBody }));

/**
 * Auth Logout
 */
export const authAuthLogout = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'auth-auth_logout',
    path: '/auth/logout',
    summary: 'Auth Logout',
    tags: ['auth']
});

/**
 * Wallet Plans
 *
 * Public membership list prices + monthly credit grants (no margin).
 */
export const walletWalletPlans = oc.route({
    description: 'Public membership list prices + monthly credit grants (no margin).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'wallet-wallet_plans',
    path: '/wallet/plans',
    summary: 'Wallet Plans',
    tags: ['wallet']
});

/**
 * Purchase Info
 */
export const walletPurchaseInfo = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'wallet-purchase_info',
    path: '/wallet/purchase-info',
    summary: 'Purchase Info',
    tags: ['wallet']
});

/**
 * Wallet Me
 */
export const walletWalletMe = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'wallet-wallet_me',
    path: '/wallet',
    summary: 'Wallet Me',
    tags: ['wallet']
});

/**
 * Wallet Ledger
 *
 * Paginated billing ledger.
 * kind=all|redeem|spend — tab filter from Usage & billing dialog.
 */
export const walletWalletLedger = oc.route({
    description: 'Paginated billing ledger.\nkind=all|redeem|spend — tab filter from Usage & billing dialog.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'wallet-wallet_ledger',
    path: '/wallet/ledger',
    summary: 'Wallet Ledger',
    tags: ['wallet']
}).input(z.object({ query: zWalletWalletLedgerQuery.optional() }).optional());

/**
 * Wallet Redeem
 */
export const walletWalletRedeem = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'wallet-wallet_redeem',
    path: '/wallet/redeem',
    summary: 'Wallet Redeem',
    tags: ['wallet']
}).input(z.object({ body: zWalletWalletRedeemBody }));

/**
 * Admin Me
 */
export const adminAdminMe = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_me',
    path: '/admin/me',
    summary: 'Admin Me',
    tags: ['admin']
});

/**
 * Admin List Users
 */
export const adminAdminListUsers = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_users',
    path: '/admin/users',
    summary: 'Admin List Users',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListUsersQuery.optional() }).optional());

/**
 * Admin Get User
 */
export const adminAdminGetUser = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_get_user',
    path: '/admin/users/{user_id}',
    summary: 'Admin Get User',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminGetUserPath }));

/**
 * Admin Patch User
 */
export const adminAdminPatchUser = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'admin-admin_patch_user',
    path: '/admin/users/{user_id}',
    summary: 'Admin Patch User',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminPatchUserBody, params: zAdminAdminPatchUserPath }));

/**
 * Admin Adjust Credits
 */
export const adminAdminAdjustCredits = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_adjust_credits',
    path: '/admin/users/{user_id}/adjust-credits',
    summary: 'Admin Adjust Credits',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminAdjustCreditsBody, params: zAdminAdminAdjustCreditsPath }));

/**
 * Admin User Ledger
 */
export const adminAdminUserLedger = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_user_ledger',
    path: '/admin/users/{user_id}/ledger',
    summary: 'Admin User Ledger',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminUserLedgerPath, query: zAdminAdminUserLedgerQuery.optional() }));

/**
 * Admin List Card Keys
 */
export const adminAdminListCardKeys = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_card_keys',
    path: '/admin/card-keys',
    summary: 'Admin List Card Keys',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListCardKeysQuery.optional() }).optional());

/**
 * Admin Generate Card Keys
 */
export const adminAdminGenerateCardKeys = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_generate_card_keys',
    path: '/admin/card-keys/generate',
    summary: 'Admin Generate Card Keys',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminGenerateCardKeysBody }));

/**
 * Admin Revoke Card Keys
 */
export const adminAdminRevokeCardKeys = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_revoke_card_keys',
    path: '/admin/card-keys/revoke',
    summary: 'Admin Revoke Card Keys',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminRevokeCardKeysBody }));

/**
 * Admin List Notices
 */
export const adminAdminListNotices = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_notices',
    path: '/admin/notices',
    summary: 'Admin List Notices',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListNoticesQuery.optional() }).optional());

/**
 * Admin Upsert Notice
 */
export const adminAdminUpsertNotice = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_upsert_notice',
    path: '/admin/notices',
    summary: 'Admin Upsert Notice',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertNoticeBody }));

/**
 * Admin Delete Notice
 */
export const adminAdminDeleteNotice = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_notice',
    path: '/admin/notices/{notice_id}',
    summary: 'Admin Delete Notice',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteNoticePath }));

/**
 * Admin Get Notice
 */
export const adminAdminGetNotice = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_get_notice',
    path: '/admin/notices/{notice_id}',
    summary: 'Admin Get Notice',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminGetNoticePath }));

/**
 * Admin Plaza List
 */
export const adminAdminPlazaList = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_plaza_list',
    path: '/admin/plaza',
    summary: 'Admin Plaza List',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminPlazaListQuery.optional() }).optional());

/**
 * Admin Plaza Approve
 */
export const adminAdminPlazaApprove = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_plaza_approve',
    path: '/admin/plaza/{submission_id}/approve',
    summary: 'Admin Plaza Approve',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminPlazaApprovePath }));

/**
 * Admin Plaza Reject
 */
export const adminAdminPlazaReject = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_plaza_reject',
    path: '/admin/plaza/{submission_id}/reject',
    summary: 'Admin Plaza Reject',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminPlazaRejectBody.optional(), params: zAdminAdminPlazaRejectPath }));

/**
 * Admin Plaza Visibility
 *
 * Toggle whether an approved plaza item shows on C-end.
 */
export const adminAdminPlazaVisibility = oc.route({
    description: 'Toggle whether an approved plaza item shows on C-end.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_plaza_visibility',
    path: '/admin/plaza/{submission_id}/visibility',
    summary: 'Admin Plaza Visibility',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminPlazaVisibilityBody, params: zAdminAdminPlazaVisibilityPath }));

/**
 * Admin Plaza Cover
 *
 * Upload / replace / clear custom plaza list cover (raster URL).
 */
export const adminAdminPlazaCover = oc.route({
    description: 'Upload / replace / clear custom plaza list cover (raster URL).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_plaza_cover',
    path: '/admin/plaza/{submission_id}/cover',
    summary: 'Admin Plaza Cover',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminPlazaCoverBody, params: zAdminAdminPlazaCoverPath }));

/**
 * Admin Plaza Title
 *
 * Rename plaza listing title (snapshot only; does not touch live project).
 */
export const adminAdminPlazaTitle = oc.route({
    description: 'Rename plaza listing title (snapshot only; does not touch live project).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_plaza_title',
    path: '/admin/plaza/{submission_id}/title',
    summary: 'Admin Plaza Title',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminPlazaTitleBody, params: zAdminAdminPlazaTitlePath }));

/**
 * Admin Plaza Delete
 *
 * Permanently remove a plaza submission (and its likes).
 */
export const adminAdminPlazaDelete = oc.route({
    description: 'Permanently remove a plaza submission (and its likes).',
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_plaza_delete',
    path: '/admin/plaza/{submission_id}',
    summary: 'Admin Plaza Delete',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminPlazaDeletePath }));

/**
 * Admin Plaza Detail
 *
 * Full submission including document — for admin canvas preview.
 */
export const adminAdminPlazaDetail = oc.route({
    description: 'Full submission including document — for admin canvas preview.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_plaza_detail',
    path: '/admin/plaza/{submission_id}',
    summary: 'Admin Plaza Detail',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminPlazaDetailPath }));

/**
 * Admin Plaza Feed
 *
 * Same shape as C-end /plaza/feed — tab=recommended|latest|following.
 */
export const adminAdminPlazaFeed = oc.route({
    description: 'Same shape as C-end /plaza/feed — tab=recommended|latest|following.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_plaza_feed',
    path: '/admin/plaza/feed',
    summary: 'Admin Plaza Feed',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminPlazaFeedQuery.optional() }).optional());

/**
 * Admin Plaza Published
 */
export const adminAdminPlazaPublished = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_plaza_published',
    path: '/admin/plaza/published',
    summary: 'Admin Plaza Published',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminPlazaPublishedQuery.optional() }).optional());

/**
 * Admin Delete Like
 */
export const adminAdminDeleteLike = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_like',
    path: '/admin/likes',
    summary: 'Admin Delete Like',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDeleteLikeQuery }));

/**
 * Admin List Likes
 */
export const adminAdminListLikes = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_likes',
    path: '/admin/likes',
    summary: 'Admin List Likes',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListLikesQuery.optional() }).optional());

/**
 * Admin List Projects
 */
export const adminAdminListProjects = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_projects',
    path: '/admin/projects',
    summary: 'Admin List Projects',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListProjectsQuery.optional() }).optional());

/**
 * Admin List Assets
 */
export const adminAdminListAssets = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_assets',
    path: '/admin/assets',
    summary: 'Admin List Assets',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListAssetsQuery.optional() }).optional());

/**
 * Admin Delete Asset
 */
export const adminAdminDeleteAsset = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_asset',
    path: '/admin/assets/{asset_id}',
    summary: 'Admin Delete Asset',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteAssetPath }));

/**
 * Admin List Image Limit Presets
 */
export const adminAdminListImageLimitPresets = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_image_limit_presets',
    path: '/admin/models/image-limit-presets',
    summary: 'Admin List Image Limit Presets',
    tags: ['admin']
});

/**
 * Admin Sync Model Prices
 *
 * Pull list prices: OpenRouter live API, or curated Ark docs snapshot.
 */
export const adminAdminSyncModelPrices = oc.route({
    description: 'Pull list prices: OpenRouter live API, or curated Ark docs snapshot.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_sync_model_prices',
    path: '/admin/models/sync-prices',
    summary: 'Admin Sync Model Prices',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminSyncModelPricesBody }));

/**
 * Admin List Models
 */
export const adminAdminListModels = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_models',
    path: '/admin/models',
    summary: 'Admin List Models',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListModelsQuery.optional() }).optional());

/**
 * Admin Upsert Model
 */
export const adminAdminUpsertModel = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_model',
    path: '/admin/models',
    summary: 'Admin Upsert Model',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertModelBody }));

/**
 * Admin Delete Model
 */
export const adminAdminDeleteModel = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_model',
    path: '/admin/models/{model_id}',
    summary: 'Admin Delete Model',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteModelPath }));

/**
 * Admin Model Usage Summary
 */
export const adminAdminModelUsageSummary = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_model_usage_summary',
    path: '/admin/model-usage/summary',
    summary: 'Admin Model Usage Summary',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminModelUsageSummaryQuery.optional() }).optional());

/**
 * Admin Model Usage List
 */
export const adminAdminModelUsageList = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_model_usage_list',
    path: '/admin/model-usage',
    summary: 'Admin Model Usage List',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminModelUsageListQuery.optional() }).optional());

/**
 * Admin List Pricing Versions
 */
export const adminAdminListPricingVersions = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_pricing_versions',
    path: '/admin/pricing-versions',
    summary: 'Admin List Pricing Versions',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListPricingVersionsQuery.optional() }).optional());

/**
 * Admin Upsert Pricing Version
 */
export const adminAdminUpsertPricingVersion = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_pricing_version',
    path: '/admin/pricing-versions',
    summary: 'Admin Upsert Pricing Version',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertPricingVersionBody }));

/**
 * Admin Get Pricing Version
 */
export const adminAdminGetPricingVersion = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_get_pricing_version',
    path: '/admin/pricing-versions/{pricing_version_id}',
    summary: 'Admin Get Pricing Version',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminGetPricingVersionPath }));

/**
 * Admin Submit Pricing Version
 */
export const adminAdminSubmitPricingVersion = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_submit_pricing_version',
    path: '/admin/pricing-versions/{pricing_version_id}/submit',
    summary: 'Admin Submit Pricing Version',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminSubmitPricingVersionPath }));

/**
 * Admin Approve Pricing Version
 */
export const adminAdminApprovePricingVersion = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_approve_pricing_version',
    path: '/admin/pricing-versions/{pricing_version_id}/approve',
    summary: 'Admin Approve Pricing Version',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminApprovePricingVersionPath }));

/**
 * Admin Reject Pricing Version
 */
export const adminAdminRejectPricingVersion = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_reject_pricing_version',
    path: '/admin/pricing-versions/{pricing_version_id}/reject',
    summary: 'Admin Reject Pricing Version',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminRejectPricingVersionBody.optional(), params: zAdminAdminRejectPricingVersionPath }));

/**
 * Admin Margin Summary
 */
export const adminAdminMarginSummary = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_margin_summary',
    path: '/admin/margin/summary',
    summary: 'Admin Margin Summary',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminMarginSummaryQuery.optional() }).optional());

/**
 * Admin Billing Quote
 *
 * Optional remote credit quote (credits only); else OSS TaskPricing authorize.
 */
export const adminAdminBillingQuote = oc.route({
    description: 'Optional remote credit quote (credits only); else OSS TaskPricing authorize.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_billing_quote',
    path: '/admin/billing/quote',
    summary: 'Admin Billing Quote',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminBillingQuoteBody.optional() }).optional());

/**
 * Admin List Task Pricing
 */
export const adminAdminListTaskPricing = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_task_pricing',
    path: '/admin/task-pricing',
    summary: 'Admin List Task Pricing',
    tags: ['admin']
});

/**
 * Admin Design Runtime Settings
 */
export const adminAdminDesignRuntimeSettings = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_runtime_settings',
    path: '/admin/design/runtime-settings',
    summary: 'Admin Design Runtime Settings',
    tags: ['admin']
});

/**
 * Admin Upsert Design Runtime Setting
 */
export const adminAdminUpsertDesignRuntimeSetting = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_runtime_setting',
    path: '/admin/design/runtime-settings',
    summary: 'Admin Upsert Design Runtime Setting',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignRuntimeSettingBody }));

/**
 * Admin Design System Prompts
 */
export const adminAdminDesignSystemPrompts = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_system_prompts',
    path: '/admin/design/system-prompts',
    summary: 'Admin Design System Prompts',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignSystemPromptsQuery.optional() }).optional());

/**
 * Admin Upsert Design System Prompt
 */
export const adminAdminUpsertDesignSystemPrompt = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_system_prompt',
    path: '/admin/design/system-prompts',
    summary: 'Admin Upsert Design System Prompt',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignSystemPromptBody }));

/**
 * Admin Design Content Resync
 *
 * Cleanup obsolete keys. Does not restore Skill/Flow/Rules UI.
 */
export const adminAdminDesignContentResync = oc.route({
    description: 'Cleanup obsolete keys. Does not restore Skill/Flow/Rules UI.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_design_content_resync',
    path: '/admin/design/content/resync',
    summary: 'Admin Design Content Resync',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignContentResyncQuery.optional() }).optional());

/**
 * Admin Design Canvas Tools
 */
export const adminAdminDesignCanvasTools = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_canvas_tools',
    path: '/admin/design/canvas-tools',
    summary: 'Admin Design Canvas Tools',
    tags: ['admin']
});

/**
 * Admin Upsert Design Canvas Tool
 */
export const adminAdminUpsertDesignCanvasTool = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_canvas_tool',
    path: '/admin/design/canvas-tools',
    summary: 'Admin Upsert Design Canvas Tool',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignCanvasToolBody }));

/**
 * Admin Design Metrics
 */
export const adminAdminDesignMetrics = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_metrics',
    path: '/admin/design/metrics',
    summary: 'Admin Design Metrics',
    tags: ['admin']
});

/**
 * Admin Design Observability
 *
 * Langfuse status for Admin 运行复盘.
 */
export const adminAdminDesignObservability = oc.route({
    description: 'Langfuse status for Admin 运行复盘.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_observability',
    path: '/admin/design/observability',
    summary: 'Admin Design Observability',
    tags: ['admin']
});

/**
 * Admin Design Decision Logs
 */
export const adminAdminDesignDecisionLogs = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_decision_logs',
    path: '/admin/design/decision-logs',
    summary: 'Admin Design Decision Logs',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignDecisionLogsQuery.optional() }).optional());

/**
 * Admin Design Decision Log Detail
 */
export const adminAdminDesignDecisionLogDetail = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_decision_log_detail',
    path: '/admin/design/decision-logs/{task_id}',
    summary: 'Admin Design Decision Log Detail',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDesignDecisionLogDetailPath }));

/**
 * Admin Design Decision Logs Clear
 *
 * Wipe persisted decision_log / execution_log (fresh LangGraph 运行复盘).
 */
export const adminAdminDesignDecisionLogsClear = oc.route({
    description: 'Wipe persisted decision_log / execution_log (fresh LangGraph 运行复盘).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_design_decision_logs_clear',
    path: '/admin/design/decision-logs/clear',
    summary: 'Admin Design Decision Logs Clear',
    tags: ['admin']
});

/**
 * Admin Design Stage Reviews
 *
 * Historical stage ratings.
 */
export const adminAdminDesignStageReviews = oc.route({
    description: 'Historical stage ratings.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_stage_reviews',
    path: '/admin/design/stage-reviews',
    summary: 'Admin Design Stage Reviews',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignStageReviewsQuery.optional() }).optional());

/**
 * Admin List Optimize Patches
 */
export const adminAdminListOptimizePatches = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_optimize_patches',
    path: '/admin/design/optimize/patches',
    summary: 'Admin List Optimize Patches',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListOptimizePatchesQuery.optional() }).optional());

/**
 * Admin Generate Optimize Patches
 *
 * Mine usage metrics into pending patches (no auto-apply).
 */
export const adminAdminGenerateOptimizePatches = oc.route({
    description: 'Mine usage metrics into pending patches (no auto-apply).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_generate_optimize_patches',
    path: '/admin/design/optimize/generate',
    summary: 'Admin Generate Optimize Patches',
    tags: ['admin']
});

/**
 * Admin Apply Optimize Patch
 */
export const adminAdminApplyOptimizePatch = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_apply_optimize_patch',
    path: '/admin/design/optimize/patches/{patch_id}/apply',
    summary: 'Admin Apply Optimize Patch',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminApplyOptimizePatchPath }));

/**
 * Admin Dismiss Optimize Patch
 */
export const adminAdminDismissOptimizePatch = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_dismiss_optimize_patch',
    path: '/admin/design/optimize/patches/{patch_id}/dismiss',
    summary: 'Admin Dismiss Optimize Patch',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDismissOptimizePatchPath }));

/**
 * Admin Design Dict Types
 */
export const adminAdminDesignDictTypes = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_dict_types',
    path: '/admin/design/dict-types',
    summary: 'Admin Design Dict Types',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignDictTypesQuery.optional() }).optional());

/**
 * Admin Upsert Design Dict Type
 */
export const adminAdminUpsertDesignDictType = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_dict_type',
    path: '/admin/design/dict-types',
    summary: 'Admin Upsert Design Dict Type',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignDictTypeBody }));

/**
 * Admin Delete Design Dict Type
 */
export const adminAdminDeleteDesignDictType = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_design_dict_type',
    path: '/admin/design/dict-types/{type_id}',
    summary: 'Admin Delete Design Dict Type',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteDesignDictTypePath }));

/**
 * Admin Design Dicts
 */
export const adminAdminDesignDicts = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_dicts',
    path: '/admin/design/dicts',
    summary: 'Admin Design Dicts',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignDictsQuery.optional() }).optional());

/**
 * Admin Upsert Design Dict
 */
export const adminAdminUpsertDesignDict = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_dict',
    path: '/admin/design/dicts',
    summary: 'Admin Upsert Design Dict',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignDictBody }));

/**
 * Admin Delete Design Dict
 */
export const adminAdminDeleteDesignDict = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_design_dict',
    path: '/admin/design/dicts/{item_id}',
    summary: 'Admin Delete Design Dict',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteDesignDictPath, query: zAdminAdminDeleteDesignDictQuery.optional() }));

/**
 * Admin Design Skills
 */
export const adminAdminDesignSkills = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_design_skills',
    path: '/admin/design/skills',
    summary: 'Admin Design Skills',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminDesignSkillsQuery.optional() }).optional());

/**
 * Admin Upsert Design Skill
 */
export const adminAdminUpsertDesignSkill = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'admin-admin_upsert_design_skill',
    path: '/admin/design/skills',
    summary: 'Admin Upsert Design Skill',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertDesignSkillBody }));

/**
 * Admin Delete Design Skill
 */
export const adminAdminDeleteDesignSkill = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_design_skill',
    path: '/admin/design/skills/{skill_id}',
    summary: 'Admin Delete Design Skill',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteDesignSkillPath }));

/**
 * Admin Resync Design Skills
 *
 * Re-run seed (insert-only) + file skill sync; never overwrites source=admin.
 */
export const adminAdminResyncDesignSkills = oc.route({
    description: 'Re-run seed (insert-only) + file skill sync; never overwrites source=admin.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_resync_design_skills',
    path: '/admin/design/skills/resync',
    summary: 'Admin Resync Design Skills',
    tags: ['admin']
});

/**
 * Admin List Kg Triples
 *
 * Inspect agent_kg_triple SPO rows (P3 knowledge graph).
 */
export const adminAdminListKgTriples = oc.route({
    description: 'Inspect agent_kg_triple SPO rows (P3 knowledge graph).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_kg_triples',
    path: '/admin/design/kg-triples',
    summary: 'Admin List Kg Triples',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListKgTriplesQuery.optional() }).optional());

/**
 * Admin Delete Kg Triple
 */
export const adminAdminDeleteKgTriple = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_kg_triple',
    path: '/admin/design/kg-triples/{triple_id}',
    summary: 'Admin Delete Kg Triple',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteKgTriplePath }));

/**
 * Admin Run Cold Archive
 *
 * Archive old design_task.result_svg + chat_messages.thinking into design_cold_blob.
 */
export const adminAdminRunColdArchive = oc.route({
    description: 'Archive old design_task.result_svg + chat_messages.thinking into design_cold_blob.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_run_cold_archive',
    path: '/admin/design/cold-archive/run',
    summary: 'Admin Run Cold Archive',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminRunColdArchiveQuery.optional() }).optional());

/**
 * Admin List Fonts
 */
export const adminAdminListFonts = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_fonts',
    path: '/admin/fonts',
    summary: 'Admin List Fonts',
    tags: ['admin']
}).input(z.object({ query: zAdminAdminListFontsQuery.optional() }).optional());

/**
 * Admin Upsert Font
 */
export const adminAdminUpsertFont = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_upsert_font',
    path: '/admin/fonts',
    summary: 'Admin Upsert Font',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminUpsertFontBody }));

/**
 * Admin Fonts Upload
 *
 * Upload a font file and register/merge as a catalog face.
 */
export const adminAdminFontsUpload = oc.route({
    description: 'Upload a font file and register/merge as a catalog face.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_fonts_upload',
    path: '/admin/fonts/upload',
    summary: 'Admin Fonts Upload',
    tags: ['admin']
}).input(z.object({ body: zAdminAdminFontsUploadBody }));

/**
 * Admin Delete Font
 */
export const adminAdminDeleteFont = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_font',
    path: '/admin/fonts/{family}',
    summary: 'Admin Delete Font',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteFontPath }));

/**
 * Admin Delete Font Face
 */
export const adminAdminDeleteFontFace = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_delete_font_face',
    path: '/admin/fonts/{family}/faces/{weight}',
    summary: 'Admin Delete Font Face',
    tags: ['admin']
}).input(z.object({ params: zAdminAdminDeleteFontFacePath }));

/**
 * Admin List Hydrate Dlq
 */
export const adminAdminListHydrateDlq = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_hydrate_dlq',
    path: '/admin/ops/hydrate-dlq',
    summary: 'Admin List Hydrate Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ query: zAdminAdminListHydrateDlqQuery.optional() }).optional());

/**
 * Admin Replay Hydrate Dlq
 */
export const adminAdminReplayHydrateDlq = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_replay_hydrate_dlq',
    path: '/admin/ops/hydrate-dlq/replay',
    summary: 'Admin Replay Hydrate Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ body: zAdminAdminReplayHydrateDlqBody }));

/**
 * Admin Discard Hydrate Dlq
 */
export const adminAdminDiscardHydrateDlq = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_discard_hydrate_dlq',
    path: '/admin/ops/hydrate-dlq/{job_id}',
    summary: 'Admin Discard Hydrate Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ params: zAdminAdminDiscardHydrateDlqPath }));

/**
 * Admin List Export Dlq
 */
export const adminAdminListExportDlq = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'admin-admin_list_export_dlq',
    path: '/admin/ops/export-dlq',
    summary: 'Admin List Export Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ query: zAdminAdminListExportDlqQuery.optional() }).optional());

/**
 * Admin Replay Export Dlq
 */
export const adminAdminReplayExportDlq = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'admin-admin_replay_export_dlq',
    path: '/admin/ops/export-dlq/replay',
    summary: 'Admin Replay Export Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ body: zAdminAdminReplayExportDlqBody }));

/**
 * Admin Discard Export Dlq
 */
export const adminAdminDiscardExportDlq = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'admin-admin_discard_export_dlq',
    path: '/admin/ops/export-dlq/{job_id}',
    summary: 'Admin Discard Export Dlq',
    tags: ['admin', 'admin-ops']
}).input(z.object({ params: zAdminAdminDiscardExportDlqPath }));

/**
 * Me Liked List
 */
export const meMeLikedList = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'me-me_liked_list',
    path: '/me/liked',
    summary: 'Me Liked List',
    tags: ['me']
}).input(z.object({ query: zMeMeLikedListQuery.optional() }).optional());

/**
 * Me Liked Ids
 */
export const meMeLikedIds = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'me-me_liked_ids',
    path: '/me/liked/ids',
    summary: 'Me Liked Ids',
    tags: ['me']
});

/**
 * Me Unlike
 */
export const meMeUnlike = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'me-me_unlike',
    path: '/me/liked/{submission_id}',
    summary: 'Me Unlike',
    tags: ['me']
}).input(z.object({ params: zMeMeUnlikePath }));

/**
 * Me Like
 */
export const meMeLike = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'me-me_like',
    path: '/me/liked/{submission_id}',
    summary: 'Me Like',
    tags: ['me']
}).input(z.object({ params: zMeMeLikePath }));

/**
 * Me Liked Sync
 *
 * One-shot migrate from client-local like ids.
 */
export const meMeLikedSync = oc.route({
    description: 'One-shot migrate from client-local like ids.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'me-me_liked_sync',
    path: '/me/liked/sync',
    summary: 'Me Liked Sync',
    tags: ['me']
}).input(z.object({ body: zMeMeLikedSyncBody }));

/**
 * Me Byok List
 *
 * List BYOK providers — never returns plaintext apiKey.
 */
export const meMeByokList = oc.route({
    description: 'List BYOK providers — never returns plaintext apiKey.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'me-me_byok_list',
    path: '/me/byok/providers',
    summary: 'Me Byok List',
    tags: ['me']
});

/**
 * Me Byok Upsert
 */
export const meMeByokUpsert = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'me-me_byok_upsert',
    path: '/me/byok/providers',
    summary: 'Me Byok Upsert',
    tags: ['me']
}).input(z.object({ body: zMeMeByokUpsertBody }));

/**
 * Me Byok Delete
 */
export const meMeByokDelete = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'me-me_byok_delete',
    path: '/me/byok/providers/{provider_id}',
    summary: 'Me Byok Delete',
    tags: ['me']
}).input(z.object({ params: zMeMeByokDeletePath }));

/**
 * Users Search
 */
export const usersUsersSearch = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'users-users_search',
    path: '/users/search',
    summary: 'Users Search',
    tags: ['users']
}).input(z.object({ query: zUsersUsersSearchQuery.optional() }).optional());

/**
 * Users Lookup
 */
export const usersUsersLookup = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'users-users_lookup',
    path: '/users/lookup',
    summary: 'Users Lookup',
    tags: ['users']
}).input(z.object({ query: zUsersUsersLookupQuery.optional() }).optional());

/**
 * Notices List
 */
export const noticesNoticesList = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'notices-notices_list',
    path: '/notices',
    summary: 'Notices List',
    tags: ['notices']
}).input(z.object({ query: zNoticesNoticesListQuery.optional() }).optional());

/**
 * Create Org
 */
export const orgsCreateOrg = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'orgs-create_org',
    path: '/orgs',
    summary: 'Create Org',
    tags: ['orgs']
}).input(z.object({ body: zOrgsCreateOrgBody }));

/**
 * List My Orgs
 */
export const orgsListMyOrgs = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'orgs-list_my_orgs',
    path: '/orgs/mine',
    summary: 'List My Orgs',
    tags: ['orgs']
});

/**
 * List My Pending Invites
 */
export const orgsListMyPendingInvites = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'orgs-list_my_pending_invites',
    path: '/orgs/invites/mine',
    summary: 'List My Pending Invites',
    tags: ['orgs']
});

/**
 * Accept Invite
 */
export const orgsAcceptInvite = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'orgs-accept_invite',
    path: '/orgs/invites/{invite_id}/accept',
    summary: 'Accept Invite',
    tags: ['orgs']
}).input(z.object({ params: zOrgsAcceptInvitePath }));

/**
 * Decline Invite
 */
export const orgsDeclineInvite = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'orgs-decline_invite',
    path: '/orgs/invites/{invite_id}/decline',
    summary: 'Decline Invite',
    tags: ['orgs']
}).input(z.object({ params: zOrgsDeclineInvitePath }));

/**
 * Get Org
 */
export const orgsGetOrg = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'orgs-get_org',
    path: '/orgs/{org_id}',
    summary: 'Get Org',
    tags: ['orgs']
}).input(z.object({ params: zOrgsGetOrgPath }));

/**
 * Rename Org
 */
export const orgsRenameOrg = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'orgs-rename_org',
    path: '/orgs/{org_id}',
    summary: 'Rename Org',
    tags: ['orgs']
}).input(z.object({ body: zOrgsRenameOrgBody, params: zOrgsRenameOrgPath }));

/**
 * List Members
 */
export const orgsListMembers = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'orgs-list_members',
    path: '/orgs/{org_id}/members',
    summary: 'List Members',
    tags: ['orgs']
}).input(z.object({ params: zOrgsListMembersPath }));

/**
 * Invite Member
 *
 * Create a pending invite (membership starts after accept).
 */
export const orgsInviteMember = oc.route({
    description: 'Create a pending invite (membership starts after accept).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'orgs-invite_member',
    path: '/orgs/{org_id}/members',
    summary: 'Invite Member',
    tags: ['orgs']
}).input(z.object({ body: zOrgsInviteMemberBody, params: zOrgsInviteMemberPath }));

/**
 * Remove Member
 */
export const orgsRemoveMember = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'orgs-remove_member',
    path: '/orgs/{org_id}/members/{user_id}',
    summary: 'Remove Member',
    tags: ['orgs']
}).input(z.object({ params: zOrgsRemoveMemberPath }));

/**
 * List Org Pending Invites
 */
export const orgsListOrgPendingInvites = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'orgs-list_org_pending_invites',
    path: '/orgs/{org_id}/invites',
    summary: 'List Org Pending Invites',
    tags: ['orgs']
}).input(z.object({ params: zOrgsListOrgPendingInvitesPath }));

/**
 * Plaza Submit
 */
export const plazaPlazaSubmit = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'plaza-plaza_submit',
    path: '/plaza/submit',
    summary: 'Plaza Submit',
    tags: ['plaza']
}).input(z.object({ body: zPlazaPlazaSubmitBody }));

/**
 * Plaza Feed
 *
 * Public plaza feed (no login required).
 * tab=recommended|latest
 * category=optional category filter (website|mobile|image|poster|video)
 */
export const plazaPlazaFeed = oc.route({
    description: 'Public plaza feed (no login required).\ntab=recommended|latest\ncategory=optional category filter (website|mobile|image|poster|video)',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'plaza-plaza_feed',
    path: '/plaza/feed',
    summary: 'Plaza Feed',
    tags: ['plaza']
}).input(z.object({ query: zPlazaPlazaFeedQuery.optional() }).optional());

/**
 * Plaza Item
 */
export const plazaPlazaItem = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'plaza-plaza_item',
    path: '/plaza/items/{submission_id}',
    summary: 'Plaza Item',
    tags: ['plaza']
}).input(z.object({ params: zPlazaPlazaItemPath }));

/**
 * Plaza Item Use
 *
 * Public (or auth-optional): bump use_count when someone applies a plaza case.
 */
export const plazaPlazaItemUse = oc.route({
    description: 'Public (or auth-optional): bump use_count when someone applies a plaza case.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'plaza-plaza_item_use',
    path: '/plaza/items/{submission_id}/use',
    summary: 'Plaza Item Use',
    tags: ['plaza']
}).input(z.object({ params: zPlazaPlazaItemUsePath }));

/**
 * Plaza Admin List
 */
export const plazaPlazaAdminList = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'plaza-plaza_admin_list',
    path: '/plaza/admin/list',
    summary: 'Plaza Admin List',
    tags: ['plaza']
}).input(z.object({ query: zPlazaPlazaAdminListQuery.optional() }).optional());

/**
 * Plaza Admin Approve
 */
export const plazaPlazaAdminApprove = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'plaza-plaza_admin_approve',
    path: '/plaza/admin/{submission_id}/approve',
    summary: 'Plaza Admin Approve',
    tags: ['plaza']
}).input(z.object({ params: zPlazaPlazaAdminApprovePath }));

/**
 * Plaza Admin Reject
 */
export const plazaPlazaAdminReject = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'plaza-plaza_admin_reject',
    path: '/plaza/admin/{submission_id}/reject',
    summary: 'Plaza Admin Reject',
    tags: ['plaza']
}).input(z.object({ body: zPlazaPlazaAdminRejectBody.optional(), params: zPlazaPlazaAdminRejectPath }));

/**
 * List My Projects
 */
export const projectsListMyProjects = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'projects-list_my_projects',
    path: '/projects',
    summary: 'List My Projects',
    tags: ['projects']
}).input(z.object({ query: zProjectsListMyProjectsQuery.optional() }).optional());

/**
 * Upsert
 */
export const projectsUpsert = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'projects-upsert',
    path: '/projects',
    summary: 'Upsert',
    tags: ['projects']
}).input(z.object({ body: zProjectsUpsertBody, headers: zProjectsUpsertHeaders.optional() }));

/**
 * Batch Remove
 */
export const projectsBatchRemove = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'projects-batch_remove',
    path: '/projects/batch-delete',
    summary: 'Batch Remove',
    tags: ['projects']
}).input(z.object({ body: zProjectsBatchRemoveBody }));

/**
 * Remove
 */
export const projectsRemove = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'projects-remove',
    path: '/projects/{project_id}',
    summary: 'Remove',
    tags: ['projects']
}).input(z.object({ params: zProjectsRemovePath }));

/**
 * Get One
 */
export const projectsGetOne = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'projects-get_one',
    path: '/projects/{project_id}',
    summary: 'Get One',
    tags: ['projects']
}).input(z.object({ params: zProjectsGetOnePath }));

/**
 * Patch One
 */
export const projectsPatchOne = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'projects-patch_one',
    path: '/projects/{project_id}',
    summary: 'Patch One',
    tags: ['projects']
}).input(z.object({
    body: zProjectsPatchOneBody,
    headers: zProjectsPatchOneHeaders.optional(),
    params: zProjectsPatchOnePath
}));

/**
 * Set Project Org
 */
export const projectsSetProjectOrg = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'projects-set_project_org',
    path: '/projects/{project_id}/org',
    summary: 'Set Project Org',
    tags: ['projects']
}).input(z.object({ body: zProjectsSetProjectOrgBody, params: zProjectsSetProjectOrgPath }));

/**
 * Shares Create
 */
export const sharesSharesCreate = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'shares-shares_create',
    path: '/shares',
    summary: 'Shares Create',
    tags: ['shares']
}).input(z.object({ body: zSharesSharesCreateBody }));

/**
 * Shares Get
 */
export const sharesSharesGet = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'shares-shares_get',
    path: '/shares/{share_id}',
    summary: 'Shares Get',
    tags: ['shares']
}).input(z.object({ params: zSharesSharesGetPath }));

/**
 * Shares Patch
 */
export const sharesSharesPatch = oc.route({
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'shares-shares_patch',
    path: '/shares/{share_id}',
    summary: 'Shares Patch',
    tags: ['shares']
}).input(z.object({ body: zSharesSharesPatchBody, params: zSharesSharesPatchPath }));

/**
 * Shares Update Document
 */
export const sharesSharesUpdateDocument = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'shares-shares_update_document',
    path: '/shares/{share_id}/document',
    summary: 'Shares Update Document',
    tags: ['shares']
}).input(z.object({ body: zSharesSharesUpdateDocumentBody, params: zSharesSharesUpdateDocumentPath }));

/**
 * Collab Room Token
 */
export const collabCollabRoomToken = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'collab-collab_room_token',
    path: '/collab/room-token',
    summary: 'Collab Room Token',
    tags: ['collab']
}).input(z.object({ body: zCollabCollabRoomTokenBody }));

/**
 * List Fonts Endpoint
 */
export const fontsListFontsEndpoint = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'fonts-list_fonts_endpoint',
    path: '/fonts',
    summary: 'List Fonts Endpoint',
    tags: ['fonts']
}).input(z.object({ query: zFontsListFontsEndpointQuery.optional() }).optional());

/**
 * Register Font
 *
 * Add/update a catalog font from URLs (auth required). Merges by weight.
 */
export const fontsRegisterFont = oc.route({
    description: 'Add/update a catalog font from URLs (auth required). Merges by weight.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'fonts-register_font',
    path: '/fonts/register',
    summary: 'Register Font',
    tags: ['fonts']
}).input(z.object({ body: zFontsRegisterFontBody }));

/**
 * Upload Font File
 *
 * Upload a font file, store it, and register as a catalog face.
 */
export const fontsUploadFontFile = oc.route({
    description: 'Upload a font file, store it, and register as a catalog face.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'fonts-upload_font_file',
    path: '/fonts/upload',
    summary: 'Upload Font File',
    tags: ['fonts']
}).input(z.object({ body: zFontsUploadFontFileBody }));

/**
 * Delete My Font
 */
export const fontsDeleteMyFont = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'fonts-delete_my_font',
    path: '/fonts/mine/{family}',
    summary: 'Delete My Font',
    tags: ['fonts']
}).input(z.object({ params: zFontsDeleteMyFontPath }));

/**
 * List My Assets
 */
export const assetsListMyAssets = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'assets-list_my_assets',
    path: '/assets',
    summary: 'List My Assets',
    tags: ['assets']
}).input(z.object({ query: zAssetsListMyAssetsQuery.optional() }).optional());

/**
 * Register My Asset
 */
export const assetsRegisterMyAsset = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'assets-register_my_asset',
    path: '/assets/register',
    summary: 'Register My Asset',
    tags: ['assets']
}).input(z.object({ body: zAssetsRegisterMyAssetBody }));

/**
 * Delete My Asset
 */
export const assetsDeleteMyAsset = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'assets-delete_my_asset',
    path: '/assets/{asset_id}',
    summary: 'Delete My Asset',
    tags: ['assets']
}).input(z.object({ params: zAssetsDeleteMyAssetPath }));

/**
 * Get Upload Content By Url
 *
 * Resolve an image display URL to bytes (same-origin for canvas crop/export).
 *
 * 1. Owned upload/asset object key → read from storage
 * 2. Else http(s) remote (Seedream/Ark TOS, etc.) → server-side proxy (avoids CORS)
 */
export const uploadsGetUploadContentByUrl = oc.route({
    description: 'Resolve an image display URL to bytes (same-origin for canvas crop/export).\n\n1. Owned upload/asset object key → read from storage\n2. Else http(s) remote (Seedream/Ark TOS, etc.) → server-side proxy (avoids CORS)',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'uploads-get_upload_content_by_url',
    path: '/uploads/content',
    summary: 'Get Upload Content By Url',
    tags: ['uploads']
}).input(z.object({ query: zUploadsGetUploadContentByUrlQuery }));

/**
 * Delete Uploaded File
 *
 * Delete a previously uploaded object owned by the current user.
 */
export const uploadsDeleteUploadedFile = oc.route({
    description: 'Delete a previously uploaded object owned by the current user.',
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'uploads-delete_uploaded_file',
    path: '/uploads/files/{object_key}',
    summary: 'Delete Uploaded File',
    tags: ['uploads']
}).input(z.object({ params: zUploadsDeleteUploadedFilePath }));

/**
 * Get Uploaded File
 *
 * Serve stored uploads by object key (local disk or S3/COS via get_bytes).
 *
 * Project list covers (``projects/{user}/{project}/thumb-*``) are public so
 * ``<img src>`` works without Authorization. Other keys still require login + ownership.
 */
export const uploadsGetUploadedFile = oc.route({
    description: 'Serve stored uploads by object key (local disk or S3/COS via get_bytes).\n\nProject list covers (``projects/{user}/{project}/thumb-*``) are public so\n``<img src>`` works without Authorization. Other keys still require login + ownership.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'uploads-get_uploaded_file',
    path: '/uploads/files/{object_key}',
    summary: 'Get Uploaded File',
    tags: ['uploads']
}).input(z.object({ params: zUploadsGetUploadedFilePath }));

/**
 * Create Upload Session
 */
export const uploadsCreateUploadSession = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'uploads-create_upload_session',
    path: '/uploads/jobs/session',
    summary: 'Create Upload Session',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ body: zUploadsCreateUploadSessionBody }));

/**
 * Upload Job Part
 */
export const uploadsUploadJobPart = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'uploads-upload_job_part',
    path: '/uploads/jobs/{job_id}/parts/{part_number}',
    summary: 'Upload Job Part',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ params: zUploadsUploadJobPartPath }));

/**
 * Complete Upload Job
 */
export const uploadsCompleteUploadJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'uploads-complete_upload_job',
    path: '/uploads/jobs/{job_id}/complete',
    summary: 'Complete Upload Job',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ params: zUploadsCompleteUploadJobPath }));

/**
 * Abort Upload Job
 */
export const uploadsAbortUploadJob = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'uploads-abort_upload_job',
    path: '/uploads/jobs/{job_id}',
    summary: 'Abort Upload Job',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ params: zUploadsAbortUploadJobPath }));

/**
 * Get Upload Job
 */
export const uploadsGetUploadJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'uploads-get_upload_job',
    path: '/uploads/jobs/{job_id}',
    summary: 'Get Upload Job',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ params: zUploadsGetUploadJobPath }));

/**
 * Stream Upload Job Events
 */
export const uploadsStreamUploadJobEvents = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'uploads-stream_upload_job_events',
    path: '/uploads/jobs/{job_id}/events',
    summary: 'Stream Upload Job Events',
    tags: ['uploads', 'upload-jobs']
}).input(z.object({ params: zUploadsStreamUploadJobEventsPath }));

/**
 * Get Sessions
 */
export const chatSessionsGetSessions = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-sessions-get_sessions',
    path: '/chat-sessions/sessions',
    summary: 'Get Sessions',
    tags: ['chat-sessions']
}).input(z.object({ query: zChatSessionsGetSessionsQuery.optional() }).optional());

/**
 * Put Session
 */
export const chatSessionsPutSession = oc.route({
    inputStructure: 'detailed',
    method: 'PUT',
    operationId: 'chat-sessions-put_session',
    path: '/chat-sessions/sessions',
    summary: 'Put Session',
    tags: ['chat-sessions']
}).input(z.object({ body: zChatSessionsPutSessionBody }));

/**
 * Remove Session
 */
export const chatSessionsRemoveSession = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'chat-sessions-remove_session',
    path: '/chat-sessions/sessions/{session_id}',
    summary: 'Remove Session',
    tags: ['chat-sessions']
}).input(z.object({ params: zChatSessionsRemoveSessionPath }));

/**
 * Import Image
 */
export const importImportImage = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'import-import_image',
    path: '/import/image',
    summary: 'Import Image',
    tags: ['import']
}).input(z.object({ body: zImportImportImageBody }));

/**
 * Create Import Job
 */
export const importJobsCreateImportJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'import-jobs-create_import_job',
    path: '/import/jobs',
    summary: 'Create Import Job',
    tags: ['import-jobs']
}).input(z.object({ body: zImportJobsCreateImportJobBody }));

/**
 * Get Import Job
 */
export const importJobsGetImportJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'import-jobs-get_import_job',
    path: '/import/jobs/{job_id}',
    summary: 'Get Import Job',
    tags: ['import-jobs']
}).input(z.object({ params: zImportJobsGetImportJobPath }));

/**
 * Create Hydrate Job
 */
export const designHydrateJobsCreateHydrateJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-hydrate-jobs-create_hydrate_job',
    path: '/design/hydrate/jobs',
    summary: 'Create Hydrate Job',
    tags: ['design-hydrate-jobs']
}).input(z.object({ body: zDesignHydrateJobsCreateHydrateJobBody }));

/**
 * Get Hydrate Job
 */
export const designHydrateJobsGetHydrateJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-hydrate-jobs-get_hydrate_job',
    path: '/design/hydrate/jobs/{job_id}',
    summary: 'Get Hydrate Job',
    tags: ['design-hydrate-jobs']
}).input(z.object({ params: zDesignHydrateJobsGetHydrateJobPath }));

/**
 * Create Export Job
 */
export const designExportJobsCreateExportJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-export-jobs-create_export_job',
    path: '/design/export/jobs',
    summary: 'Create Export Job',
    tags: ['design-export-jobs']
}).input(z.object({ body: zDesignExportJobsCreateExportJobBody }));

/**
 * Get Export Job
 */
export const designExportJobsGetExportJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-export-jobs-get_export_job',
    path: '/design/export/jobs/{job_id}',
    summary: 'Get Export Job',
    tags: ['design-export-jobs']
}).input(z.object({ params: zDesignExportJobsGetExportJobPath }));

/**
 * Download Export Job
 */
export const designExportJobsDownloadExportJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-export-jobs-download_export_job',
    path: '/design/export/jobs/{job_id}/file',
    summary: 'Download Export Job',
    tags: ['design-export-jobs']
}).input(z.object({ params: zDesignExportJobsDownloadExportJobPath }));

/**
 * Create Image Job
 */
export const chatImageJobsCreateImageJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-image-jobs-create_image_job',
    path: '/chat/image/jobs',
    summary: 'Create Image Job',
    tags: ['chat-image-jobs']
}).input(z.object({ body: zChatImageJobsCreateImageJobBody }));

/**
 * Get Image Job
 */
export const chatImageJobsGetImageJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-image-jobs-get_image_job',
    path: '/chat/image/jobs/{job_id}',
    summary: 'Get Image Job',
    tags: ['chat-image-jobs']
}).input(z.object({ params: zChatImageJobsGetImageJobPath }));

/**
 * Stream Image Job Events
 *
 * SSE push for job status (progress / done / failed).
 */
export const chatImageJobsStreamImageJobEvents = oc.route({
    description: 'SSE push for job status (progress / done / failed).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-image-jobs-stream_image_job_events',
    path: '/chat/image/jobs/{job_id}/events',
    summary: 'Stream Image Job Events',
    tags: ['chat-image-jobs']
}).input(z.object({ params: zChatImageJobsStreamImageJobEventsPath }));

/**
 * Create Video Job
 */
export const chatVideoJobsCreateVideoJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-video-jobs-create_video_job',
    path: '/chat/video/jobs',
    summary: 'Create Video Job',
    tags: ['chat-video-jobs']
}).input(z.object({ body: zChatVideoJobsCreateVideoJobBody }));

/**
 * Get Video Job
 */
export const chatVideoJobsGetVideoJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-video-jobs-get_video_job',
    path: '/chat/video/jobs/{job_id}',
    summary: 'Get Video Job',
    tags: ['chat-video-jobs']
}).input(z.object({ params: zChatVideoJobsGetVideoJobPath }));

/**
 * Stream Video Job Events
 *
 * SSE push for job status (progress / done / failed).
 */
export const chatVideoJobsStreamVideoJobEvents = oc.route({
    description: 'SSE push for job status (progress / done / failed).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-video-jobs-stream_video_job_events',
    path: '/chat/video/jobs/{job_id}/events',
    summary: 'Stream Video Job Events',
    tags: ['chat-video-jobs']
}).input(z.object({ params: zChatVideoJobsStreamVideoJobEventsPath }));

/**
 * Create Audio Job
 */
export const chatAudioJobsCreateAudioJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-audio-jobs-create_audio_job',
    path: '/chat/audio/jobs',
    summary: 'Create Audio Job',
    tags: ['chat-audio-jobs']
}).input(z.object({ body: zChatAudioJobsCreateAudioJobBody }));

/**
 * Get Audio Job
 */
export const chatAudioJobsGetAudioJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-audio-jobs-get_audio_job',
    path: '/chat/audio/jobs/{job_id}',
    summary: 'Get Audio Job',
    tags: ['chat-audio-jobs']
}).input(z.object({ params: zChatAudioJobsGetAudioJobPath }));

/**
 * Stream Audio Job Events
 *
 * SSE push for job status (progress / done / failed).
 */
export const chatAudioJobsStreamAudioJobEvents = oc.route({
    description: 'SSE push for job status (progress / done / failed).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-audio-jobs-stream_audio_job_events',
    path: '/chat/audio/jobs/{job_id}/events',
    summary: 'Stream Audio Job Events',
    tags: ['chat-audio-jobs']
}).input(z.object({ params: zChatAudioJobsStreamAudioJobEventsPath }));

/**
 * Create Lottie Job
 */
export const chatLottieJobsCreateLottieJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-lottie-jobs-create_lottie_job',
    path: '/chat/lottie/jobs',
    summary: 'Create Lottie Job',
    tags: ['chat-lottie-jobs']
}).input(z.object({ body: zChatLottieJobsCreateLottieJobBody }));

/**
 * Get Lottie Job
 */
export const chatLottieJobsGetLottieJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-lottie-jobs-get_lottie_job',
    path: '/chat/lottie/jobs/{job_id}',
    summary: 'Get Lottie Job',
    tags: ['chat-lottie-jobs']
}).input(z.object({ params: zChatLottieJobsGetLottieJobPath }));

/**
 * Stream Lottie Job Events
 *
 * SSE push for job status (progress / done / failed).
 */
export const chatLottieJobsStreamLottieJobEvents = oc.route({
    description: 'SSE push for job status (progress / done / failed).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-lottie-jobs-stream_lottie_job_events',
    path: '/chat/lottie/jobs/{job_id}/events',
    summary: 'Stream Lottie Job Events',
    tags: ['chat-lottie-jobs']
}).input(z.object({ params: zChatLottieJobsStreamLottieJobEventsPath }));

/**
 * Get Models
 */
export const chatGetModels = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-get_models',
    path: '/chat/models',
    summary: 'Get Models',
    tags: ['chat']
});

/**
 * Post Message
 */
export const chatPostMessage = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-post_message',
    path: '/chat/message',
    summary: 'Post Message',
    tags: ['chat']
}).input(z.object({ body: zChatPostMessageBody }));

/**
 * Get Agent Tools
 */
export const chatGetAgentTools = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'chat-get_agent_tools',
    path: '/chat/agent/tools',
    summary: 'Get Agent Tools',
    tags: ['chat']
});

/**
 * Post Agent Turn
 *
 * Stream agent turn.
 *
 * - mode=turn (default): bind_tools; canvas tools for the frontend.
 * - mode=react: official LangChain create_agent (server tools loop).
 */
export const chatPostAgentTurn = oc.route({
    description: 'Stream agent turn.\n\n- mode=turn (default): bind_tools; canvas tools for the frontend.\n- mode=react: official LangChain create_agent (server tools loop).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-post_agent_turn',
    path: '/chat/agent',
    summary: 'Post Agent Turn',
    tags: ['chat']
}).input(z.object({ body: zChatPostAgentTurnBody }));

/**
 * Post Image
 */
export const chatPostImage = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-post_image',
    path: '/chat/image',
    summary: 'Post Image',
    tags: ['chat']
}).input(z.object({ body: zChatPostImageBody }));

/**
 * Post Video
 *
 * Sync convenience. Editor uses POST /chat/video/jobs (ADR 0005).
 */
export const chatPostVideo = oc.route({
    description: 'Sync convenience. Editor uses POST /chat/video/jobs (ADR 0005).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-post_video',
    path: '/chat/video',
    summary: 'Post Video',
    tags: ['chat']
}).input(z.object({ body: zChatPostVideoBody }));

/**
 * Post Audio
 *
 * Sync convenience. Editor uses POST /chat/audio/jobs (ADR 0005).
 */
export const chatPostAudio = oc.route({
    description: 'Sync convenience. Editor uses POST /chat/audio/jobs (ADR 0005).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'chat-post_audio',
    path: '/chat/audio',
    summary: 'Post Audio',
    tags: ['chat']
}).input(z.object({ body: zChatPostAudioBody }));

/**
 * List Image Tools
 */
export const imageToolsListImageTools = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'image-tools-list_image_tools',
    path: '/image/tools',
    summary: 'List Image Tools',
    tags: ['image-tools']
});

/**
 * Post Image Process
 */
export const imageToolsPostImageProcess = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'image-tools-post_image_process',
    path: '/image/process',
    summary: 'Post Image Process',
    tags: ['image-tools']
}).input(z.object({ body: zImageToolsPostImageProcessBody }));

/**
 * Create Image Process Job
 */
export const imageProcessJobsCreateImageProcessJob = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'image-process-jobs-create_image_process_job',
    path: '/image/process/jobs',
    summary: 'Create Image Process Job',
    tags: ['image-process-jobs']
}).input(z.object({ body: zImageProcessJobsCreateImageProcessJobBody }));

/**
 * Get Image Process Job
 */
export const imageProcessJobsGetImageProcessJob = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'image-process-jobs-get_image_process_job',
    path: '/image/process/jobs/{job_id}',
    summary: 'Get Image Process Job',
    tags: ['image-process-jobs']
}).input(z.object({ params: zImageProcessJobsGetImageProcessJobPath }));

/**
 * Stream Image Process Job Events
 *
 * SSE push for toolbar image job status (progress / done / failed).
 */
export const imageProcessJobsStreamImageProcessJobEvents = oc.route({
    description: 'SSE push for toolbar image job status (progress / done / failed).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'image-process-jobs-stream_image_process_job_events',
    path: '/image/process/jobs/{job_id}/events',
    summary: 'Stream Image Process Job Events',
    tags: ['image-process-jobs']
}).input(z.object({ params: zImageProcessJobsStreamImageProcessJobEventsPath }));

/**
 * List Mockup Tools
 */
export const mockupListMockupTools = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'mockup-list_mockup_tools',
    path: '/mockup/tools',
    summary: 'List Mockup Tools',
    tags: ['mockup']
});

/**
 * Get Mockup Template Kit
 *
 * Proxy Intelligence template kit (UV/mask/base) for FE WebGL preview.
 */
export const mockupGetMockupTemplateKit = oc.route({
    description: 'Proxy Intelligence template kit (UV/mask/base) for FE WebGL preview.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'mockup-get_mockup_template_kit',
    path: '/mockup/templates/{template_id}/kit',
    summary: 'Get Mockup Template Kit',
    tags: ['mockup']
}).input(z.object({ params: zMockupGetMockupTemplateKitPath, query: zMockupGetMockupTemplateKitQuery.optional() }));

/**
 * Post Mockup Auto Bake
 *
 * Full-auto: product photo → printable zones + UV + shadow/highlight kit.
 *
 * Called when the user enables 样机 on a product image.
 */
export const mockupPostMockupAutoBake = oc.route({
    description: 'Full-auto: product photo → printable zones + UV + shadow/highlight kit.\n\nCalled when the user enables 样机 on a product image.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mockup-post_mockup_auto_bake',
    path: '/mockup/auto-bake',
    summary: 'Post Mockup Auto Bake',
    tags: ['mockup']
}).input(z.object({ body: zMockupPostMockupAutoBakeBody }));

/**
 * Post Mockup Render
 */
export const mockupPostMockupRender = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mockup-post_mockup_render',
    path: '/mockup/render',
    summary: 'Post Mockup Render',
    tags: ['mockup']
}).input(z.object({ body: zMockupPostMockupRenderBody }));

/**
 * Post Mockup Batch Render
 */
export const mockupPostMockupBatchRender = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mockup-post_mockup_batch_render',
    path: '/mockup/render/batch',
    summary: 'Post Mockup Batch Render',
    tags: ['mockup']
}).input(z.object({ body: zMockupPostMockupBatchRenderBody }));

/**
 * Design Catalog
 */
export const designDesignCatalog = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_catalog',
    path: '/design/catalog',
    summary: 'Design Catalog',
    tags: ['design']
});

/**
 * Design Canvas Tools
 *
 * Public capability table — FE executes ops by the same op_key.
 */
export const designDesignCanvasTools = oc.route({
    description: 'Public capability table — FE executes ops by the same op_key.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_canvas_tools',
    path: '/design/canvas-tools',
    summary: 'Design Canvas Tools',
    tags: ['design']
});

/**
 * Design Skills Picker
 *
 * Skills for `/` picker, mine list, or toolbox (`manage=true`, includes disabled).
 */
export const designDesignSkillsPicker = oc.route({
    description: 'Skills for `/` picker, mine list, or toolbox (`manage=true`, includes disabled).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_skills_picker',
    path: '/design/skills',
    summary: 'Design Skills Picker',
    tags: ['design']
}).input(z.object({ query: zDesignDesignSkillsPickerQuery.optional() }).optional());

/**
 * Design Skills Upsert
 */
export const designDesignSkillsUpsert = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_skills_upsert',
    path: '/design/skills',
    summary: 'Design Skills Upsert',
    tags: ['design']
}).input(z.object({ body: zDesignDesignSkillsUpsertBody }));

/**
 * Design Skills Import Zip
 *
 * Upload a skill / plugin pack — scan, optional overwrite, then save.
 */
export const designDesignSkillsImportZip = oc.route({
    description: 'Upload a skill / plugin pack — scan, optional overwrite, then save.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_skills_import_zip',
    path: '/design/skills/import',
    summary: 'Design Skills Import Zip',
    tags: ['design']
}).input(z.object({ body: zDesignDesignSkillsImportZipBody }));

/**
 * Design Plugins Install
 *
 * Install a branded ``.recombyn-plugin`` pack (skill → user DB; canvas → disk when enabled).
 */
export const designDesignPluginsInstall = oc.route({
    description: 'Install a branded ``.recombyn-plugin`` pack (skill → user DB; canvas → disk when enabled).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_plugins_install',
    path: '/design/plugins/install',
    summary: 'Design Plugins Install',
    tags: ['design']
}).input(z.object({ body: zDesignDesignPluginsInstallBody }));

/**
 * Design Skills Set Enabled
 *
 * Per-user on/off for toolbox switches (official via prefs; mine via row+pref).
 */
export const designDesignSkillsSetEnabled = oc.route({
    description: 'Per-user on/off for toolbox switches (official via prefs; mine via row+pref).',
    inputStructure: 'detailed',
    method: 'PATCH',
    operationId: 'design-design_skills_set_enabled',
    path: '/design/skills/{skill_id}/enabled',
    summary: 'Design Skills Set Enabled',
    tags: ['design']
}).input(z.object({ body: zDesignDesignSkillsSetEnabledBody, params: zDesignDesignSkillsSetEnabledPath }));

/**
 * Design Skills Delete
 */
export const designDesignSkillsDelete = oc.route({
    inputStructure: 'detailed',
    method: 'DELETE',
    operationId: 'design-design_skills_delete',
    path: '/design/skills/{skill_id}',
    summary: 'Design Skills Delete',
    tags: ['design']
}).input(z.object({ params: zDesignDesignSkillsDeletePath }));

/**
 * Design Run
 */
export const designDesignRun = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run',
    path: '/design/run',
    summary: 'Design Run',
    tags: ['design']
}).input(z.object({ body: zDesignDesignRunBody }));

/**
 * Design Run Scene Feedback
 *
 * FE posts real canvas inventory after applying tool_ops (between agent rounds).
 */
export const designDesignRunSceneFeedback = oc.route({
    description: 'FE posts real canvas inventory after applying tool_ops (between agent rounds).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run_scene_feedback',
    path: '/design/run/{task_id}/scene',
    summary: 'Design Run Scene Feedback',
    tags: ['design']
}).input(z.object({ body: zDesignDesignRunSceneFeedbackBody, params: zDesignDesignRunSceneFeedbackPath }));

/**
 * Design Run Status
 */
export const designDesignRunStatus = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_run_status',
    path: '/design/run/{task_id}',
    summary: 'Design Run Status',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunStatusPath }));

/**
 * Design Run Events
 *
 * Replay the safe product timeline after an SSE reconnect.
 */
export const designDesignRunEvents = oc.route({
    description: 'Replay the safe product timeline after an SSE reconnect.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_run_events',
    path: '/design/run/{task_id}/events',
    summary: 'Design Run Events',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunEventsPath, query: zDesignDesignRunEventsQuery.optional() }));

/**
 * Design Run Trace
 *
 * Model-lane session trace for eval/debug (no canvas payloads).
 */
export const designDesignRunTrace = oc.route({
    description: 'Model-lane session trace for eval/debug (no canvas payloads).',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_run_trace',
    path: '/design/run/{task_id}/trace',
    summary: 'Design Run Trace',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunTracePath, query: zDesignDesignRunTraceQuery.optional() }));

/**
 * Design Run Commands
 */
export const designDesignRunCommands = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'design-design_run_commands',
    path: '/design/run/{task_id}/commands',
    summary: 'Design Run Commands',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunCommandsPath, query: zDesignDesignRunCommandsQuery.optional() }));

/**
 * Design Run Commands Ack
 */
export const designDesignRunCommandsAck = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run_commands_ack',
    path: '/design/run/{task_id}/commands/ack',
    summary: 'Design Run Commands Ack',
    tags: ['design']
}).input(z.object({ body: zDesignDesignRunCommandsAckBody, params: zDesignDesignRunCommandsAckPath }));

/**
 * Design Run Pause
 */
export const designDesignRunPause = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run_pause',
    path: '/design/run/{task_id}/pause',
    summary: 'Design Run Pause',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunPausePath }));

/**
 * Design Run Cancel
 */
export const designDesignRunCancel = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run_cancel',
    path: '/design/run/{task_id}/cancel',
    summary: 'Design Run Cancel',
    tags: ['design']
}).input(z.object({ params: zDesignDesignRunCancelPath }));

/**
 * Design Run Resume
 *
 * Resume a paused / waiting_client / resumable-error design run (SSE).
 */
export const designDesignRunResume = oc.route({
    description: 'Resume a paused / waiting_client / resumable-error design run (SSE).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_run_resume',
    path: '/design/run/{task_id}/resume',
    summary: 'Design Run Resume',
    tags: ['design']
}).input(z.object({ body: zDesignDesignRunResumeBody.optional(), params: zDesignDesignRunResumePath }));

/**
 * Design Lottie Generate
 *
 * Generate Bodymovin JSON for the on-canvas Lottie generator plate.
 */
export const designDesignLottieGenerate = oc.route({
    description: 'Generate Bodymovin JSON for the on-canvas Lottie generator plate.',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_lottie_generate',
    path: '/design/lottie/generate',
    summary: 'Design Lottie Generate',
    tags: ['design']
}).input(z.object({ body: zDesignDesignLottieGenerateBody }));

/**
 * Design Long Memory
 *
 * Persist user-confirmed long-term preference (M4 entry point).
 */
export const designDesignLongMemory = oc.route({
    description: 'Persist user-confirmed long-term preference (M4 entry point).',
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'design-design_long_memory',
    path: '/design/memory/long',
    summary: 'Design Long Memory',
    tags: ['design']
}).input(z.object({ body: zDesignDesignLongMemoryBody }));

/**
 * List Tools
 */
export const mcpCanvasListTools = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'mcp-canvas-list_tools',
    path: '/mcp/canvas/tools',
    summary: 'List Tools',
    tags: ['mcp-canvas']
});

/**
 * Call Tool
 */
export const mcpCanvasCallTool = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mcp-canvas-call_tool',
    path: '/mcp/canvas/call',
    summary: 'Call Tool',
    tags: ['mcp-canvas']
}).input(z.object({ body: zMcpCanvasCallToolBody }));

/**
 * Session Heartbeat
 */
export const mcpCanvasSessionHeartbeat = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mcp-canvas-session_heartbeat',
    path: '/mcp/canvas/session/heartbeat',
    summary: 'Session Heartbeat',
    tags: ['mcp-canvas']
}).input(z.object({ body: zMcpCanvasSessionHeartbeatBody }));

/**
 * List Pending
 */
export const mcpCanvasListPending = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'mcp-canvas-list_pending',
    path: '/mcp/canvas/pending',
    summary: 'List Pending',
    tags: ['mcp-canvas']
}).input(z.object({ query: zMcpCanvasListPendingQuery }));

/**
 * Ack Pending
 */
export const mcpCanvasAckPending = oc.route({
    inputStructure: 'detailed',
    method: 'POST',
    operationId: 'mcp-canvas-ack_pending',
    path: '/mcp/canvas/pending/ack',
    summary: 'Ack Pending',
    tags: ['mcp-canvas']
}).input(z.object({ body: zMcpCanvasAckPendingBody }));

/**
 * Metrics
 *
 * Endpoint that serves Prometheus metrics.
 */
export const healthMetrics = oc.route({
    description: 'Endpoint that serves Prometheus metrics.',
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'health-metrics',
    path: '/metrics',
    summary: 'Metrics',
    tags: ['health']
});

/**
 * Root
 */
export const apiRoot = oc.route({
    inputStructure: 'detailed',
    method: 'GET',
    operationId: 'api-root',
    path: '/',
    summary: 'Root',
    tags: ['default']
});

export const contract = {
    healthHealth,
    authAuthConfig,
    authAuthGoogle,
    authEmailSendCode,
    authEmailActivate,
    authEmailVerifyCode,
    authCaptchaCreate,
    authCaptchaVerify,
    authEmailLogin,
    authAuthMe,
    authAuthPatchProfile,
    authAuthLogout,
    walletWalletPlans,
    walletPurchaseInfo,
    walletWalletMe,
    walletWalletLedger,
    walletWalletRedeem,
    adminAdminMe,
    adminAdminListUsers,
    adminAdminGetUser,
    adminAdminPatchUser,
    adminAdminAdjustCredits,
    adminAdminUserLedger,
    adminAdminListCardKeys,
    adminAdminGenerateCardKeys,
    adminAdminRevokeCardKeys,
    adminAdminListNotices,
    adminAdminUpsertNotice,
    adminAdminDeleteNotice,
    adminAdminGetNotice,
    adminAdminPlazaList,
    adminAdminPlazaApprove,
    adminAdminPlazaReject,
    adminAdminPlazaVisibility,
    adminAdminPlazaCover,
    adminAdminPlazaTitle,
    adminAdminPlazaDelete,
    adminAdminPlazaDetail,
    adminAdminPlazaFeed,
    adminAdminPlazaPublished,
    adminAdminDeleteLike,
    adminAdminListLikes,
    adminAdminListProjects,
    adminAdminListAssets,
    adminAdminDeleteAsset,
    adminAdminListImageLimitPresets,
    adminAdminSyncModelPrices,
    adminAdminListModels,
    adminAdminUpsertModel,
    adminAdminDeleteModel,
    adminAdminModelUsageSummary,
    adminAdminModelUsageList,
    adminAdminListPricingVersions,
    adminAdminUpsertPricingVersion,
    adminAdminGetPricingVersion,
    adminAdminSubmitPricingVersion,
    adminAdminApprovePricingVersion,
    adminAdminRejectPricingVersion,
    adminAdminMarginSummary,
    adminAdminBillingQuote,
    adminAdminListTaskPricing,
    adminAdminDesignRuntimeSettings,
    adminAdminUpsertDesignRuntimeSetting,
    adminAdminDesignSystemPrompts,
    adminAdminUpsertDesignSystemPrompt,
    adminAdminDesignContentResync,
    adminAdminDesignCanvasTools,
    adminAdminUpsertDesignCanvasTool,
    adminAdminDesignMetrics,
    adminAdminDesignObservability,
    adminAdminDesignDecisionLogs,
    adminAdminDesignDecisionLogDetail,
    adminAdminDesignDecisionLogsClear,
    adminAdminDesignStageReviews,
    adminAdminListOptimizePatches,
    adminAdminGenerateOptimizePatches,
    adminAdminApplyOptimizePatch,
    adminAdminDismissOptimizePatch,
    adminAdminDesignDictTypes,
    adminAdminUpsertDesignDictType,
    adminAdminDeleteDesignDictType,
    adminAdminDesignDicts,
    adminAdminUpsertDesignDict,
    adminAdminDeleteDesignDict,
    adminAdminDesignSkills,
    adminAdminUpsertDesignSkill,
    adminAdminDeleteDesignSkill,
    adminAdminResyncDesignSkills,
    adminAdminListKgTriples,
    adminAdminDeleteKgTriple,
    adminAdminRunColdArchive,
    adminAdminListFonts,
    adminAdminUpsertFont,
    adminAdminFontsUpload,
    adminAdminDeleteFont,
    adminAdminDeleteFontFace,
    adminAdminListHydrateDlq,
    adminAdminReplayHydrateDlq,
    adminAdminDiscardHydrateDlq,
    adminAdminListExportDlq,
    adminAdminReplayExportDlq,
    adminAdminDiscardExportDlq,
    meMeLikedList,
    meMeLikedIds,
    meMeUnlike,
    meMeLike,
    meMeLikedSync,
    meMeByokList,
    meMeByokUpsert,
    meMeByokDelete,
    usersUsersSearch,
    usersUsersLookup,
    noticesNoticesList,
    orgsCreateOrg,
    orgsListMyOrgs,
    orgsListMyPendingInvites,
    orgsAcceptInvite,
    orgsDeclineInvite,
    orgsGetOrg,
    orgsRenameOrg,
    orgsListMembers,
    orgsInviteMember,
    orgsRemoveMember,
    orgsListOrgPendingInvites,
    plazaPlazaSubmit,
    plazaPlazaFeed,
    plazaPlazaItem,
    plazaPlazaItemUse,
    plazaPlazaAdminList,
    plazaPlazaAdminApprove,
    plazaPlazaAdminReject,
    projectsListMyProjects,
    projectsUpsert,
    projectsBatchRemove,
    projectsRemove,
    projectsGetOne,
    projectsPatchOne,
    projectsSetProjectOrg,
    sharesSharesCreate,
    sharesSharesGet,
    sharesSharesPatch,
    sharesSharesUpdateDocument,
    collabCollabRoomToken,
    fontsListFontsEndpoint,
    fontsRegisterFont,
    fontsUploadFontFile,
    fontsDeleteMyFont,
    assetsListMyAssets,
    assetsRegisterMyAsset,
    assetsDeleteMyAsset,
    uploadsGetUploadContentByUrl,
    uploadsDeleteUploadedFile,
    uploadsGetUploadedFile,
    uploadsCreateUploadSession,
    uploadsUploadJobPart,
    uploadsCompleteUploadJob,
    uploadsAbortUploadJob,
    uploadsGetUploadJob,
    uploadsStreamUploadJobEvents,
    chatSessionsGetSessions,
    chatSessionsPutSession,
    chatSessionsRemoveSession,
    importImportImage,
    importJobsCreateImportJob,
    importJobsGetImportJob,
    designHydrateJobsCreateHydrateJob,
    designHydrateJobsGetHydrateJob,
    designExportJobsCreateExportJob,
    designExportJobsGetExportJob,
    designExportJobsDownloadExportJob,
    chatImageJobsCreateImageJob,
    chatImageJobsGetImageJob,
    chatImageJobsStreamImageJobEvents,
    chatVideoJobsCreateVideoJob,
    chatVideoJobsGetVideoJob,
    chatVideoJobsStreamVideoJobEvents,
    chatAudioJobsCreateAudioJob,
    chatAudioJobsGetAudioJob,
    chatAudioJobsStreamAudioJobEvents,
    chatLottieJobsCreateLottieJob,
    chatLottieJobsGetLottieJob,
    chatLottieJobsStreamLottieJobEvents,
    chatGetModels,
    chatPostMessage,
    chatGetAgentTools,
    chatPostAgentTurn,
    chatPostImage,
    chatPostVideo,
    chatPostAudio,
    imageToolsListImageTools,
    imageToolsPostImageProcess,
    imageProcessJobsCreateImageProcessJob,
    imageProcessJobsGetImageProcessJob,
    imageProcessJobsStreamImageProcessJobEvents,
    mockupListMockupTools,
    mockupGetMockupTemplateKit,
    mockupPostMockupAutoBake,
    mockupPostMockupRender,
    mockupPostMockupBatchRender,
    designDesignCatalog,
    designDesignCanvasTools,
    designDesignSkillsPicker,
    designDesignSkillsUpsert,
    designDesignSkillsImportZip,
    designDesignPluginsInstall,
    designDesignSkillsSetEnabled,
    designDesignSkillsDelete,
    designDesignRun,
    designDesignRunSceneFeedback,
    designDesignRunStatus,
    designDesignRunEvents,
    designDesignRunTrace,
    designDesignRunCommands,
    designDesignRunCommandsAck,
    designDesignRunPause,
    designDesignRunCancel,
    designDesignRunResume,
    designDesignLottieGenerate,
    designDesignLongMemory,
    mcpCanvasListTools,
    mcpCanvasCallTool,
    mcpCanvasSessionHeartbeat,
    mcpCanvasListPending,
    mcpCanvasAckPending,
    healthMetrics,
    apiRoot
};
